import styles from './Footer.module.scss';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <span>
                &copy; 2025 PwC. All rights reserved. PwC refers to the PwC network and/or one or more of its member
                firms, each of which is a separate legal entity. Please see{' '}
                <a
                    className={styles['footer-link']}
                    href="https://www.pwc.com/structure"
                    target="_blank"
                    rel="noopener noreferrer">
                    www.pwc.com/structure
                </a>{' '}
                for further details.
            </span>
        </footer>
    );
};

export default Footer;
